var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLockLaminatedOpen = function SvgIconLockLaminatedOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.868 2.483a2.375 2.375 0 0 1 2.494 2.122 1 1 0 0 0 1.989-.21 4.375 4.375 0 0 0-8.726.483V7.25H4.5A1.75 1.75 0 0 0 2.75 9v10.5c0 .966.784 1.75 1.75 1.75h15a1.75 1.75 0 0 0 1.75-1.75V9a1.75 1.75 0 0 0-1.75-1.75H9.625V4.869a2.375 2.375 0 0 1 2.243-2.386M8.614 9.25H19.25v2.125H4.75V9.25zM4.75 13.375v1.75h14.5v-1.75zm0 5.875v-2.125h14.5v2.125z",
    clipRule: "evenodd"
  })));
};
export default SvgIconLockLaminatedOpen;